require('babel-polyfill');
require('./util/configureQwest.jsx');

const ReactDOM = require('react-dom');
const {browserHistory} = require('react-router');

const createRouter = require('./router.jsx');

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(createRouter(browserHistory), document.getElementById('body'));
});
